module.exports = __webpack_public_path__ + "img/Inspection personnel.05da7950.png";